import { useEffect, type ReactNode } from 'react';
import { useUserPendingUploads } from '../hooks/usePendingUploads';
import { PendingUploadsContext } from './pendingUploadsContextValue';

/**
 * The signed-in person's uploads, read once for the whole app (Ryan, 29 Oct:
 * the pinned upload bar and its Pending Uploads sheet are gone; a lesson row
 * says "Preparing" and its page says the match is processing). It keeps the
 * two duties the bar had: while a file is going up, leaving the page asks
 * first, and a new version does not reload under it (data-upload-active,
 * main.tsx).
 */
export function PendingUploadsProvider({ children }: { children: ReactNode }) {
  const { uploads } = useUserPendingUploads();
  const going = uploads.some((u) => u.status === 'uploading');
  useEffect(() => {
    if (!going) return;
    const stay = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ''; // required by Chrome to trigger the native dialog
    };
    window.addEventListener('beforeunload', stay);
    document.body.setAttribute('data-upload-active', 'true');
    return () => {
      window.removeEventListener('beforeunload', stay);
      document.body.removeAttribute('data-upload-active');
    };
  }, [going]);
  return <PendingUploadsContext.Provider value={uploads}>{children}</PendingUploadsContext.Provider>;
}
